import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './copytrading.css';
import Swal from 'sweetalert2';

const futuresSlides = [
    {
        tag: "Newbie Exclusive 2.0",
        title: "Protect Your 1st Copy Trade Claim 20 USDT Subsidy...",
        linkText: "Claim Now →",
        imgSrc: "/images/copy-trading-img/copy_trading_hero_img.jpg"
    },
    {
        tag: "Pro Traders",
        title: "Join the Elite Ranks Get up to 30% profit share",
        linkText: "Apply Now →",
        imgSrc: "/images/copy-trading-img/copy_trading_hero_img2.jpg"
    },
    {
        tag: "Special Offer",
        title: "Trade & Win Big Unlock 50 USDT Bonus",
        linkText: "Learn More →",
        imgSrc: "/images/copy-trading-img/copy_trading_hero_img.jpg"
    }
];

const cfdSlides = [
    {
        tag: "Newbie Exclusive 2.0",
        title: "Claim Your 20 USDT Welcome Reward",
        linkText: "Claim Now →",
        imgSrc: "/images/copy-trading-img/copy_trading_hero_img2.jpg"
    },
    {
        tag: "Master CFD Traders",
        title: "Copy top forex & indices traders. Up to 40% profit sharing.",
        linkText: "Start Copying →",
        imgSrc: "/images/copy-trading-img/copy_trading_hero_img.jpg"
    },
    {
        tag: "Weekly CFD Contest",
        title: "Trade indices and commodities to win from 10,000 USDT pool.",
        linkText: "Join Contest →",
        imgSrc: "/images/copy-trading-img/copy_trading_hero_img.jpg"
    }
];

const futuresNewTraders = [
    { name: "Kremlin King", time: "1d ago", roi: "+2,404.14%", avatar: "/images/copy-trading-img/klostein_icon.svg" },
    { name: "ICT Trading Master", time: "4d ago", roi: "+2,389.17%", avatar: "/images/copy-trading-img/crypto_matic_icon.svg" },
    { name: "Daily Master Trader", time: "5d ago", roi: "+2,361.99%", avatar: "/images/copy-trading-img/timb_icon.svg" },
    { name: "HaiSatoshi", time: "4d ago", roi: "+2,321.11%", avatar: "/images/copy-trading-img/award_icon.svg" },
    { name: "John Doe", time: "6d ago", roi: "+1,100.00%", initial: "JD" }
];

const cfdNewTraders = [
    { name: "ForexSniper", time: "2d ago", roi: "+1,842.10%", avatar: "/images/copy-trading-img/timb_icon.svg" },
    { name: "IndexGuru", time: "3d ago", roi: "+1,620.55%", avatar: "/images/copy-trading-img/klostein_icon.svg" },
    { name: "GoldDigger", time: "5d ago", roi: "+1,490.22%", avatar: "/images/copy-trading-img/award_icon.svg" },
    { name: "OilTycoon", time: "6d ago", roi: "+1,210.88%", avatar: "/images/copy-trading-img/crypto_matic_icon.svg" },
    { name: "Jane Doe", time: "7d ago", roi: "+950.00%", initial: "JD" }
];

const futuresTraders = [
    { name: 'Dearmhe', badge: 'DE', pnl: '+30.2%', usdt: '+158.51 USDT', cpnl: '-0.63 USDT', ls: '2.7K USDT', days: '42' },
    { name: 'TheShitcoinShorter', avatar: '/images/copy-trading-img/shitcoin_icon.svg', pnl: '+28.76%', usdt: '+28.76 USDT', cpnl: '-5.42 USDT', ls: '705.5 USDT', days: '18' },
    { name: 'WolfTrade', badge: 'WO', pnl: '+19.24%', usdt: '+196.88 USDT', cpnl: '-143.98 USDT', ls: '776.0 USDT', days: '144' },
    { name: 'CryptoMatic_AI', avatar: '/images/copy-trading-img/crypto_matic_icon.svg', label: 'TradePilot', pnl: '+8.37%', usdt: '+2,847.39 USDT', cpnl: '-78.01 USDT', ls: '493.9 USDT', days: '124' },
    { name: 'ARK018', badge: 'AR', pnl: '+1.71%', usdt: '+7.00 USDT', cpnl: '0.00 USDT', ls: '60 USDT', days: '105' },
    { name: 'TradingQuest', badge: 'TR', pnl: '+260.4%', usdt: '+251.76 USDT', cpnl: '+13.04 USDT', ls: '1.4K USDT', days: '2' },
    { name: 'H4teful', badge: 'H4', pnl: '+161.71%', usdt: '+328.70 USDT', cpnl: '-84.51 USDT', ls: '3.1K USDT', days: '105' },
    { name: 'JSerekesh', badge: 'JS', pnl: '+109.88%', usdt: '+248.37 USDT', cpnl: '+18.08 USDT', ls: '428.0 USDT', days: '136' },
    { name: 'SuYiFi', badge: 'SU', pnl: '+107.77%', usdt: '+53.68 USDT', cpnl: '0.00 USDT', ls: '35.0 USDT', days: '116' },
    { name: 'TIMBO224', badge: 'TI', pnl: '+105.49%', usdt: '+114.20 USDT', cpnl: '0.00 USDT', ls: '50 USDT', days: '36' },
    { name: 'Klostein', avatar: '/images/copy-trading-img/klostein_icon.svg', pnl: '+97.07%', usdt: '+18.30 USDT', cpnl: '0.00 USDT', ls: '20 USDT', days: '176' },
    { name: 'Zelin Natural Trading T...', badge: 'TR', pnl: '+94.85%', usdt: '+94.85 USDT', cpnl: '0.00 USDT', ls: '0 USDT', days: '7' },
];

const cfdTraders = [
    { name: 'FX_Sniper', badge: 'FX', pnl: '+42.5%', usdt: '+320.10 USDT', cpnl: '+12.40 USDT', ls: '5.2K USDT', days: '64' },
    { name: 'NasdaqRider', avatar: '/images/copy-trading-img/shitcoin_icon.svg', pnl: '+38.92%', usdt: '+412.50 USDT', cpnl: '-8.12 USDT', ls: '1.2K USDT', days: '32' },
    { name: 'GoldBull', badge: 'GB', pnl: '+27.44%', usdt: '+510.15 USDT', cpnl: '+150.32 USDT', ls: '2.5K USDT', days: '89' },
    { name: 'OilMaster_AI', avatar: '/images/copy-trading-img/crypto_matic_icon.svg', label: 'CFDPilot', pnl: '+12.89%', usdt: '+1,920.40 USDT', cpnl: '-45.10 USDT', ls: '890 USDT', days: '92' },
    { name: 'EURUSD_Pro', badge: 'EU', pnl: '+5.10%', usdt: '+24.00 USDT', cpnl: '0.00 USDT', ls: '150 USDT', days: '52' },
    { name: 'DowTrader', badge: 'DT', pnl: '+185.3%', usdt: '+980.20 USDT', cpnl: '+42.10 USDT', ls: '4.8K USDT', days: '12' },
    { name: 'ForexWizard', badge: 'FW', pnl: '+120.40%', usdt: '+640.10 USDT', cpnl: '-32.40 USDT', ls: '1.8K USDT', days: '74' },
    { name: 'DAX_Scalper', badge: 'DX', pnl: '+94.20%', usdt: '+180.50 USDT', cpnl: '+15.20 USDT', ls: '620 USDT', days: '81' },
    { name: 'JPY_Hunter', badge: 'JH', pnl: '+88.10%', usdt: '+140.20 USDT', cpnl: '0.00 USDT', ls: '90 USDT', days: '44' },
    { name: 'SilverFox', badge: 'SF', pnl: '+75.20%', usdt: '+92.10 USDT', cpnl: '0.00 USDT', ls: '110 USDT', days: '25' },
    { name: 'CryptoCFD', avatar: '/images/copy-trading-img/klostein_icon.svg', pnl: '+64.10%', usdt: '+55.40 USDT', cpnl: '0.00 USDT', ls: '40 USDT', days: '112' },
    { name: 'BrentCrude', badge: 'BC', pnl: '+52.40%', usdt: '+45.10 USDT', cpnl: '0.00 USDT', ls: '10 USDT', days: '19' },
];

const futuresRisingTalents = [
    { name: 'Ten ye...', avatar: '/images/copy-trading-img/trades_img2.svg', roi: '+50.36%', copiers: '1/50' },
    { name: 'BitLan...', avatar: '/images/copy-trading-img/trades_img3.svg', roi: '+175.01%', copiers: '0/50' },
    { name: 'Dance...', avatar: '/images/copy-trading-img/trades_img4.svg', roi: '+94.15%', copiers: '3/50' }
];

const cfdRisingTalents = [
    { name: 'ForexGo...', avatar: '/images/copy-trading-img/trades_img2.svg', roi: '+88.42%', copiers: '4/50' },
    { name: 'Indices...', avatar: '/images/copy-trading-img/trades_img3.svg', roi: '+142.10%', copiers: '2/50' },
    { name: 'PipMa...', avatar: '/images/copy-trading-img/trades_img4.svg', roi: '+76.33%', copiers: '8/50' }
];

const futuresPrudentTraders = [
    { name: 'Red Ha...', avatar: '/images/copy-trading-img/prudent_img.svg', roi: '+24.41%', copiers: '4/50', type: '30D ROI' },
    { name: 'You ne...', avatar: '/images/copy-trading-img/prudent_img2.svg', roi: '+16.65%', copiers: '2/50', type: '30D ROI' },
    { name: 'Broken...', avatar: '/images/copy-trading-img/prudent_img3.svg', roi: '+24.31%', copiers: '2/50', type: '30D ROI' },
    { name: 'Leek Pr...', avatar: '/images/copy-trading-img/prudent_img4.svg', roi: '+30.10%', copiers: '29/50', type: '30D ROI' },
    { name: 'Crypto...', avatar: '/images/copy-trading-img/prudent_img5.svg', roi: '+126.17%', copiers: '5/50', type: '30D ROI' },
    { name: 'Princip...', avatar: '/images/copy-trading-img/prudent_img6.svg', roi: '+0.27%', copiers: '1/1,000', type: '30D ROI', isLocked: true }
];

const cfdPrudentTraders = [
    { name: 'SafeFX...', avatar: '/images/copy-trading-img/prudent_img.svg', roi: '+18.22%', copiers: '12/50', type: '30D ROI' },
    { name: 'GoldRisk...', avatar: '/images/copy-trading-img/prudent_img2.svg', roi: '+12.40%', copiers: '5/50', type: '30D ROI' },
    { name: 'Steady...', avatar: '/images/copy-trading-img/prudent_img3.svg', roi: '+15.90%', copiers: '3/50', type: '30D ROI' },
    { name: 'ForexLow...', avatar: '/images/copy-trading-img/prudent_img4.svg', roi: '+22.50%', copiers: '14/50', type: '30D ROI' },
    { name: 'IndexSafe...', avatar: '/images/copy-trading-img/prudent_img5.svg', roi: '+94.10%', copiers: '9/50', type: '30D ROI' },
    { name: 'US30Safe...', avatar: '/images/copy-trading-img/prudent_img6.svg', roi: '+0.45%', copiers: '2/1,000', type: '30D ROI', isLocked: true }
];

const CopyTrading = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [activeTab, setActiveTab] = useState('Futures');
    const [recommendTab, setRecommendTab] = useState('Recommend');
    const [cfdFilter, setCfdFilter] = useState("Copiers' PnL");
    const [cfdTimeRange, setCfdTimeRange] = useState("30D");
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [searchQuery, setSearchQuery] = useState('');
    const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
    const [timeRange, setTimeRange] = useState('7D');
    const [pnlMin, setPnlMin] = useState('0');
    const [pnlMax, setPnlMax] = useState('5000000');
    const [copiersPnlMin, setCopiersPnlMin] = useState('0');
    const [copiersPnlMax, setCopiersPnlMax] = useState('5000000');
    const [roiFilter, setRoiFilter] = useState('≥ 0%');
    const [mddFilter, setMddFilter] = useState('≤ 100%');
    const [joinedDays, setJoinedDays] = useState('≥ 7D');
    const [aumFilter, setAumFilter] = useState('≥ 5,000');
    const [minCopyAmount, setMinCopyAmount] = useState('≤ 10');

    // Applied filter states
    const [appliedFilters, setAppliedFilters] = useState({
        timeRange: '7D',
        pnlMin: '0',
        pnlMax: '5000000',
        copiersPnlMin: '0',
        copiersPnlMax: '5000000',
        roiFilter: '≥ 0%',
        mddFilter: '≤ 100%',
        joinedDays: '≥ 7D',
        aumFilter: '≥ 5,000',
        minCopyAmount: '≤ 10'
    });

    const handleConfirmFilters = () => {
        setAppliedFilters({
            timeRange,
            pnlMin,
            pnlMax,
            copiersPnlMin,
            copiersPnlMax,
            roiFilter,
            mddFilter,
            joinedDays,
            aumFilter,
            minCopyAmount
        });
        setIsFilterModalOpen(false);
    };

    const handleResetFilters = () => {
        setTimeRange('7D');
        setPnlMin('0');
        setPnlMax('5000000');
        setCopiersPnlMin('0');
        setCopiersPnlMax('5000000');
        setRoiFilter('≥ 0%');
        setMddFilter('≤ 100%');
        setJoinedDays('≥ 7D');
        setAumFilter('≥ 5,000');
        setMinCopyAmount('≤ 10');
    };

    const getFilteredFuturesTraders = () => {
        return futuresTraders.filter(t => {
            // Search query filter
            if (searchQuery && !t.name.toLowerCase().includes(searchQuery.toLowerCase())) {
                return false;
            }

            // PnL Filter
            const pnlVal = parseFloat(t.usdt.replace('+', '').replace(' USDT', '').replace(/,/g, '')) || 0;
            if (pnlVal < parseFloat(appliedFilters.pnlMin) || pnlVal > parseFloat(appliedFilters.pnlMax)) {
                return false;
            }

            // Copiers' PnL Filter
            const cpnlVal = parseFloat(t.cpnl.replace('+', '').replace(' USDT', '').replace(/,/g, '')) || 0;
            if (cpnlVal < parseFloat(appliedFilters.copiersPnlMin) || cpnlVal > parseFloat(appliedFilters.copiersPnlMax)) {
                return false;
            }

            // ROI Filter
            const roiVal = parseFloat(t.pnl.replace('%', '')) || 0;
            if (appliedFilters.roiFilter === '≥ 25%' && roiVal < 25) return false;
            if (appliedFilters.roiFilter === '≥ 50%' && roiVal < 50) return false;
            if (appliedFilters.roiFilter === '≥ 100%' && roiVal < 100) return false;

            // Joined Days Filter
            const daysVal = parseInt(t.days) || 0;
            if (appliedFilters.joinedDays === '≥ 7D' && daysVal < 7) return false;
            if (appliedFilters.joinedDays === '≥ 30D' && daysVal < 30) return false;
            if (appliedFilters.joinedDays === '≥ 60D' && daysVal < 60) return false;
            if (appliedFilters.joinedDays === '≥ 90D' && daysVal < 90) return false;

            // AUM Filter (Stable Mock based on Lead Size)
            const aumVal = (parseFloat(t.ls.replace('K', '').replace(' USDT', '')) * (t.ls.includes('K') ? 1000 : 1) * 3) || 5000;
            if (appliedFilters.aumFilter === '≥ 5,000' && aumVal < 5000) return false;
            if (appliedFilters.aumFilter === '≥ 10,000' && aumVal < 10000) return false;
            if (appliedFilters.aumFilter === '≥ 50,000' && aumVal < 50000) return false;
            if (appliedFilters.aumFilter === '≥ 100,000' && aumVal < 100000) return false;

            // Minimum Copy Amount Filter (Stable Mock)
            const minAmtVal = (parseFloat(t.ls.replace('K', '').replace(' USDT', '')) > 1 ? 50 : 10);
            if (appliedFilters.minCopyAmount === '≤ 10' && minAmtVal > 10) return false;
            if (appliedFilters.minCopyAmount === '≤ 50' && minAmtVal > 50) return false;
            if (appliedFilters.minCopyAmount === '≤ 100' && minAmtVal > 100) return false;

            return true;
        });
    };

    const sliderRef = React.useRef(null);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(true);

    const slides = activeTab === 'Futures' ? futuresSlides : cfdSlides;

    useEffect(() => {
        if (location.state?.activeTab) {
            setActiveTab(location.state.activeTab);
        }
    }, [location.state]);

    useEffect(() => {
        setCurrentSlide(0);
        if (activeTab === 'CFD') {
            setRecommendTab('All CFD Traders');
        } else {
            setRecommendTab('Recommend');
        }
    }, [activeTab]);

    useEffect(() => {
        setSearchQuery('');
    }, [activeTab, recommendTab]);

    const handleScroll = () => {
        if (sliderRef.current) {
            const { scrollLeft, scrollWidth, clientWidth } = sliderRef.current;
            setCanScrollLeft(scrollLeft > 0);
            setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 5);
        }
    };

    const slideRight = () => {
        if (sliderRef.current) {
            sliderRef.current.scrollBy({ left: 350, behavior: 'smooth' });
        }
    };

    const slideLeft = () => {
        if (sliderRef.current) {
            sliderRef.current.scrollBy({ left: -350, behavior: 'smooth' });
        }
    };

    const goToTraderDetail = (trader) => {
        const params = new URLSearchParams({
            trader: trader?.name || 'Dearmhe',
            tab: activeTab || 'Futures',
        });
        navigate(`/copy-trading-detail?${params.toString()}`, {
            state: { trader, activeTab },
        });
        window.scrollTo(0, 0);
    };

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % slides.length);
        }, 5000);
        return () => clearInterval(timer);
    }, [slides.length, activeTab]);

    return (
        <>
            <div className="copy_trading_page_wrapper">

                <div className="copy_trading_top_bar">
                    <div className='container'>
                        <div className='copy_trading_top_nav'>
                            <div className="tabs_left">
                                <button
                                    className={`tab_btn ${activeTab === 'Futures' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('Futures')}
                                >
                                    Futures
                                </button>
                                <button
                                    className={`tab_btn ${activeTab === 'CFD' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('CFD')}
                                >
                                    CFD
                                </button>
                            </div>
                            <div className="tabs_right">
                                <button className="help_btn">
                                    <span className="doc_icon2"><img src='/images/copy-trading-img/document_icon.svg' alt='document' /></span> Help Documentation
                                </button>
                            </div>
                        </div>
                    </div>

                </div>

                <div className="container">
                    <h1 className="hero_title">
                        {activeTab === 'Futures' ? "Copy Trading" : "CFD Copy Trading"}
                    </h1>
                    <p className="hero_desc">
                        {activeTab === 'Futures'
                            ? "Unlock smarter trading by copying top futures traders and managing your positions with ease."
                            : "Unlock a smarter way to trade by following top CFD lead traders."}
                    </p>
                    <div className="copy_trading_hero">
                        <div className="hero_left">

                            <div className="hero_stats">
                                <div className="stat_item">
                                    <h3>192,882</h3>
                                    <p>Copiers</p>
                                </div>
                                <div className="stat_item">
                                    <h3>7,340,274</h3>
                                    <p>Copier's Total Return</p>
                                </div>
                            </div>
                        </div>

                        <div className="hero_right">
                            {/* Slider */}
                            <div className="hero_slider_card">
                                <div className="slider_content">
                                    <span className="slide_tag">{slides[currentSlide].tag}</span>
                                    <h2 className="slide_title">{slides[currentSlide].title}</h2>
                                    <button className="slide_link">{slides[currentSlide].linkText}</button>
                                </div>
                                <div className="slider_image">
                                    <img src={slides[currentSlide].imgSrc} alt="promo" />
                                </div>
                                <div className="slider_pagination">
                                    {slides.map((_, index) => (
                                        <span
                                            key={index}
                                            className={`dot ${currentSlide === index ? 'active' : ''}`}
                                            onClick={() => setCurrentSlide(index)}
                                        ></span>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Traders Section */}
            <div className="traders_section_wrapper">
                <div className="container">
                    {/* New Traders Section */}
                    <div className="new_traders_section">
                        <div className="section_header">
                            <h2>New Traders</h2>
                            <div className="header_actions">
                                <button className="icon_btn"><img src="/images/copy-trading-img/edit_icon.svg" alt="edit" /></button>
                                <button className="icon_btn"><img src="/images/copy-trading-img/guide_icon.svg" alt="doc" /></button>
                                <div className="search_bar">
                                    <span className="search_icon"><i className="ri-search-line"></i></span>
                                    <input type="text" placeholder="Search trader..." />
                                </div>
                            </div>
                        </div>
                        <div className="new_traders_slider_container" style={{ position: 'relative' }}>
                            {canScrollLeft && <button className="prev_btn" onClick={slideLeft}>‹</button>}
                            <div className="new_traders_list" ref={sliderRef} onScroll={handleScroll}>
                                {(activeTab === 'Futures' ? futuresNewTraders : cfdNewTraders).map((nt, idx) => (
                                    <div
                                        className="new_trader_card"
                                        key={idx}
                                        onClick={() => goToTraderDetail(nt)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        {nt.avatar ? (
                                            <img src={nt.avatar} alt="avatar" className="nt_avatar" />
                                        ) : (
                                            <div className="tgc_avatar">{nt.initial}</div>
                                        )}
                                        <div className="nt_info">
                                            <h4>{nt.name}</h4>
                                            <p>Joined <strong>{nt.time.split(' ')[0]}</strong>d ago <span className="green_text">{nt.roi}</span></p>
                                        </div>
                                        {idx === 0 && <span className="arrow_right">›</span>}
                                    </div>
                                ))}
                            </div>
                            {canScrollRight && <button className="next_btn" onClick={slideRight}>›</button>}
                        </div>
                    </div>

                    {/* Recommend Section */}
                    <div className="recommend_section">
                        <div className="recommend_tabs">
                            {activeTab === 'Futures' && (
                                <button
                                    className={`rt_tab ${recommendTab === 'Recommend' ? 'active' : ''}`}
                                    onClick={() => setRecommendTab('Recommend')}
                                >
                                    Recommend
                                </button>
                            )}
                            <button
                                className={`rt_tab ${recommendTab === (activeTab === 'Futures' ? 'All Futures Traders' : 'All CFD Traders') ? 'active' : ''}`}
                                onClick={() => setRecommendTab(activeTab === 'Futures' ? 'All Futures Traders' : 'All CFD Traders')}
                            >
                                {activeTab === 'Futures' ? 'All Futures Traders' : 'All CFD Traders'}
                            </button>
                            <button
                                className={`rt_tab ${recommendTab === 'Favorites' ? 'active' : ''}`}
                                onClick={() => setRecommendTab('Favorites')}
                            >
                                Favorites
                            </button>
                        </div>

                        {activeTab === 'CFD' && recommendTab === 'All CFD Traders' && (
                            <div className="cfd_filter_bar">
                                <div className="cfd_filter_left">
                                    {["Copiers' PnL", "ROI", "PnL", "AUM", "Copiers", "Max Drawdown"].map((item) => (
                                        <button
                                            key={item}
                                            className={`cfd_filter_btn ${cfdFilter === item ? 'active' : ''}`}
                                            onClick={() => setCfdFilter(item)}
                                        >
                                            {item}
                                        </button>
                                    ))}
                                </div>
                                <div className="cfd_filter_right">
                                    <div className="cfd_dropdown">
                                        <button
                                            className="cfd_dropdown_btn"
                                            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                        >
                                            <span>{cfdTimeRange}</span>
                                            <i className={isDropdownOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}></i>
                                        </button>
                                        {isDropdownOpen && (
                                            <div className="cfd_dropdown_menu">
                                                {["7D", "30D", "90D"].map((range) => (
                                                    <button
                                                        key={range}
                                                        className="cfd_dropdown_item"
                                                        onClick={() => {
                                                            setCfdTimeRange(range);
                                                            setIsDropdownOpen(false);
                                                        }}
                                                    >
                                                        <span>{range}</span>
                                                        {cfdTimeRange === range && (
                                                            <span className="cfd_check_circle">
                                                                <i className="ri-check-line"></i>
                                                            </span>
                                                        )}
                                                    </button>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}

                        {activeTab === 'Futures' && recommendTab === 'All Futures Traders' && (
                            <div className="cfd_filter_bar">
                                <div className="cfd_filter_left">
                                    {["Copiers' PnL", "ROI", "PnL", "AUM", "Sharpe Ratio", "Copiers"].map((item) => (
                                        <button
                                            key={item}
                                            className={`cfd_filter_btn ${cfdFilter === item ? 'active' : ''}`}
                                            onClick={() => setCfdFilter(item)}
                                        >
                                            {item}
                                        </button>
                                    ))}
                                </div>
                                <div className="cfd_filter_right">
                                    <button className="copy_filter_btn" onClick={() => setIsFilterModalOpen(true)}>
                                        <i className="ri-filter-3-line"></i>
                                        <span>Filter</span>
                                    </button>
                                    <div className="copy_search_wrapper">
                                        <i className="ri-search-line copy_search_icon"></i>
                                        <input
                                            type="text"
                                            className="copy_search_input"
                                            placeholder="Search"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="traders_grid">
                            {(activeTab === 'Futures' ? (recommendTab === 'All Futures Traders' ? getFilteredFuturesTraders() : futuresTraders) : cfdTraders)
                                .slice(0, (recommendTab === 'All Futures Traders' || recommendTab === 'All CFD Traders') ? 9 : recommendTab === 'Favorites' ? 6 : 12)
                                .map((t, i) => (
                                    <div
                                        className="trader_grid_card clickable_trader_card"
                                        key={i}
                                        onClick={() => goToTraderDetail(t)}
                                    >
                                        <div className="tgc_header">
                                            <div className="tgc_user">
                                                {t.avatar ?
                                                    <img src={t.avatar} className="tgc_avatar_img" alt="avatar" /> :
                                                    <div className="tgc_avatar">{t.badge}</div>
                                                }
                                                <div className="tgc_name_info">
                                                    <h4>{t.name} {t.label && <span className="tgc_label">{t.label}</span>}</h4>
                                                    <p><span className="people_icon"><i className="ri-group-line"></i></span> {Math.floor(Math.random() * 10)}/1000</p>
                                                </div>
                                            </div>
                                            <button className="copy_btn" onClick={(e) => {
                                                e.stopPropagation();
                                                goToTraderDetail(t);
                                            }}>Copy</button>
                                        </div>
                                        <div className="tgc_chart_section">
                                            <div className="tgc_pnl">
                                                <p className="pnl_label">30d PNL</p>
                                                <h3 className="green_text">{t.pnl}</h3>
                                                <p className="usdt_text">{t.usdt}</p>
                                            </div>
                                            <div className="tgc_chart">
                                                <img src="/images/copy-trading-img/market_graph.svg" alt="chart" />
                                            </div>
                                        </div>
                                        <div className="tgc_stats">
                                            <div className="tgc_stat_row">
                                                <span>Copy Traders' PNL</span>
                                                <strong>{t.cpnl}</strong>
                                            </div>
                                            <div className="tgc_stat_row">
                                                <span>Lead Size</span>
                                                <strong>{t.ls}</strong>
                                            </div>
                                            <div className="tgc_stat_row">
                                                <span>Days as Lead</span>
                                                <strong>{t.days}</strong>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                        </div>
                        <div className="pagination_wrapper">
                            <button className="page_btn">‹</button>
                            <button className="page_btn active">1</button>
                            <button className="page_btn">2</button>
                            <button className="page_btn">3</button>
                            <button className="page_btn">4</button>
                            <button className="page_btn">5</button>
                            <button className="page_btn">6</button>
                            <button className="page_btn">7</button>
                            <span className="page_dots">...</span>
                            <button className="page_btn">12</button>
                            <button className="page_btn">›</button>
                        </div>
                    </div>

                    {activeTab === 'Futures' && (
                        <>
                            {/* Rising Talents Section */}
                            <div className="rising_talents_section">
                                <div className="rt_header_wrapper">
                                    <div className="rt_header_left">
                                        <h2>Rising Talents</h2>
                                        <p>Traders with high ROI in the last 7 days, based on trading performance.</p>
                                    </div>
                                    <button className="more_btn">More</button>
                                </div>
                                <div className="rising_talents_list">
                                    {(activeTab === 'Futures' ? futuresRisingTalents : cfdRisingTalents).map((t, i) => (
                                        <div className="rt_card" key={i}>
                                            <div className="rt_user">
                                                <img src={t.avatar} alt="avatar" className="rt_avatar" />
                                                <div className="rt_user_info">
                                                    <h4>{t.name} <img src="/images/copy-trading-img/award_icon.svg" alt="medal" className="medal_icon" /></h4>
                                                    <p><span className="people_icon"><i className="ri-group-line"></i></span> {t.copiers}</p>
                                                </div>
                                            </div>
                                            <div className="rt_roi">
                                                <p className="roi_label">7D ROI</p>
                                                <h3 className="green_text">{t.roi}</h3>
                                            </div>
                                            <button className="copy_btn" onClick={() => goToTraderDetail(t)}>Copy</button>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Prudent Trader Section */}
                            <div className="prudent_trader_section">
                                <div className="rt_header_wrapper">
                                    <div className="rt_header_left">
                                        <h2>Prudent Trader</h2>
                                        <p>Traders who maintain a balanced Sharpe Ratio and ROI, based on trading performance.</p>
                                    </div>
                                    <button className="more_btn">More</button>
                                </div>
                                <div className="prudent_trader_list">
                                    {(activeTab === 'Futures' ? futuresPrudentTraders : cfdPrudentTraders).map((t, i) => (
                                        <div className="rt_card" key={i}>
                                            <div className="rt_user">
                                                <img src={t.avatar} alt="avatar" className="rt_avatar" />
                                                <div className="rt_user_info">
                                                    <h4>{t.name} <img src="/images/copy-trading-img/award_icon.svg" alt="medal" className="medal_icon" /></h4>
                                                    <p><span className="people_icon"><i className="ri-group-line"></i></span> {t.copiers}</p>
                                                </div>
                                            </div>
                                            <div className="rt_roi">
                                                <p className="roi_label">{t.type}</p>
                                                <h3 className="green_text">{t.roi}</h3>
                                            </div>
                                            {t.isLocked ? (
                                                <button className="copy_btn lock_btn" onClick={() => goToTraderDetail(t)}><img src="/images/copy-trading-img/lock_icon.svg" alt="lock" className="lock_icon" /> Copy</button>
                                            ) : (
                                                <button className="copy_btn" onClick={() => goToTraderDetail(t)}>Copy</button>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </>
                    )}

                    {/* Total Profit Sharing Section */}
                    <div className="total_profit_section">
                        <p className="profit_subtitle">Total Profit Sharing on AGCX Exceeds</p>
                        <h2 className="profit_title">$2,000,000</h2>
                        <div className="profit_actions">
                            <button className="btn_apply">Apply Now</button>
                            <button className="btn_go">Go Now →</button>
                        </div>
                    </div>

                    {isFilterModalOpen && (
                        <div className="filter_modal_overlay" onClick={() => setIsFilterModalOpen(false)}>
                            <div className="filter_modal_content" onClick={(e) => e.stopPropagation()}>
                                <div className="filter_modal_header">
                                    <h3>Filter</h3>
                                    <button className="filter_modal_close" onClick={() => setIsFilterModalOpen(false)}>
                                        <i className="ri-close-line"></i>
                                    </button>
                                </div>
                                <div className="filter_modal_body">
                                    {/* Time Section */}
                                    <div className="filter_section">
                                        <label className="filter_label">Time</label>
                                        <div className="filter_buttons_row">
                                            {['7D', '30D', '90D', '180D'].map((t) => (
                                                <button
                                                    key={t}
                                                    className={`filter_row_btn ${timeRange === t ? 'active' : ''}`}
                                                    onClick={() => setTimeRange(t)}
                                                >
                                                    {t}
                                                </button>
                                            ))}
                                        </div>
                                    </div>

                            {/* 7D PnL Section */}
                            <div className="filter_section">
                                <label className="filter_label">{timeRange} PnL</label>
                                <div className="filter_range_inputs">
                                    <input
                                        type="number"
                                        value={pnlMin}
                                        onChange={(e) => {
                                            const val = Math.min(Number(e.target.value), Number(pnlMax));
                                            setPnlMin(val);
                                        }}
                                        className="filter_range_input"
                                    />
                                    <span className="filter_range_sep">-</span>
                                    <input
                                        type="number"
                                        value={pnlMax}
                                        onChange={(e) => {
                                            const val = Math.max(Number(e.target.value), Number(pnlMin));
                                            setPnlMax(val);
                                        }}
                                        className="filter_range_input"
                                    />
                                </div>
                                <div className="filter_slider_container">
                                    <div className="filter_slider_track">
                                        <div
                                            className="filter_slider_bar"
                                            style={{
                                                left: `${(Number(pnlMin) / 5000000) * 100}%`,
                                                right: `${100 - (Number(pnlMax) / 5000000) * 100}%`
                                            }}
                                        ></div>
                                    </div>
                                    <input
                                        type="range"
                                        min="0"
                                        max="5000000"
                                        step="10000"
                                        value={pnlMin}
                                        onChange={(e) => {
                                            const val = Math.min(Number(e.target.value), Number(pnlMax) - 10000);
                                            setPnlMin(val);
                                        }}
                                        className="filter_slider_range_input"
                                    />
                                    <input
                                        type="range"
                                        min="0"
                                        max="5000000"
                                        step="10000"
                                        value={pnlMax}
                                        onChange={(e) => {
                                            const val = Math.max(Number(e.target.value), Number(pnlMin) + 10000);
                                            setPnlMax(val);
                                        }}
                                        className="filter_slider_range_input"
                                    />
                                </div>
                            </div>

                            {/* 7D Copiers' PnL Section */}
                            <div className="filter_section">
                                <label className="filter_label">{timeRange} Copiers' PnL</label>
                                <div className="filter_range_inputs">
                                    <input
                                        type="number"
                                        value={copiersPnlMin}
                                        onChange={(e) => {
                                            const val = Math.min(Number(e.target.value), Number(copiersPnlMax));
                                            setCopiersPnlMin(val);
                                        }}
                                        className="filter_range_input"
                                    />
                                    <span className="filter_range_sep">-</span>
                                    <input
                                        type="number"
                                        value={copiersPnlMax}
                                        onChange={(e) => {
                                            const val = Math.max(Number(e.target.value), Number(copiersPnlMin));
                                            setCopiersPnlMax(val);
                                        }}
                                        className="filter_range_input"
                                    />
                                </div>
                                <div className="filter_slider_container">
                                    <div className="filter_slider_track">
                                        <div
                                            className="filter_slider_bar"
                                            style={{
                                                left: `${(Number(copiersPnlMin) / 5000000) * 100}%`,
                                                right: `${100 - (Number(copiersPnlMax) / 5000000) * 100}%`
                                            }}
                                        ></div>
                                    </div>
                                    <input
                                        type="range"
                                        min="0"
                                        max="5000000"
                                        step="10000"
                                        value={copiersPnlMin}
                                        onChange={(e) => {
                                            const val = Math.min(Number(e.target.value), Number(copiersPnlMax) - 10000);
                                            setCopiersPnlMin(val);
                                        }}
                                        className="filter_slider_range_input"
                                    />
                                    <input
                                        type="range"
                                        min="0"
                                        max="5000000"
                                        step="10000"
                                        value={copiersPnlMax}
                                        onChange={(e) => {
                                            const val = Math.max(Number(e.target.value), Number(copiersPnlMin) + 10000);
                                            setCopiersPnlMax(val);
                                        }}
                                        className="filter_slider_range_input"
                                    />
                                </div>
                            </div>

                                    {/* 7D ROI Section */}
                                    <div className="filter_section">
                                        <label className="filter_label">{timeRange} ROI</label>
                                        <div className="filter_buttons_row">
                                            {['≥ 0%', '≥ 25%', '≥ 50%', '≥ 100%'].map((r) => (
                                                <button
                                                    key={r}
                                                    className={`filter_row_btn ${roiFilter === r ? 'active' : ''}`}
                                                    onClick={() => setRoiFilter(r)}
                                                >
                                                    {r}
                                                </button>
                                            ))}
                                        </div>
                                    </div>

                                    {/* 7D MDD Section */}
                                    <div className="filter_section">
                                        <label className="filter_label">{timeRange} MDD</label>
                                        <div className="filter_buttons_row">
                                            {['≤ 10%', '≤ 30%', '≤ 50%', '≤ 100%'].map((m) => (
                                                <button
                                                    key={m}
                                                    className={`filter_row_btn ${mddFilter === m ? 'active' : ''}`}
                                                    onClick={() => setMddFilter(m)}
                                                >
                                                    {m}
                                                </button>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Joined Day(s) Section */}
                                    <div className="filter_section">
                                        <label className="filter_label">Joined Day(s)</label>
                                        <div className="filter_buttons_row">
                                            {['≥ 7D', '≥ 30D', '≥ 60D', '≥ 90D'].map((d) => (
                                                <button
                                                    key={d}
                                                    className={`filter_row_btn ${joinedDays === d ? 'active' : ''}`}
                                                    onClick={() => setJoinedDays(d)}
                                                >
                                                    {d}
                                                </button>
                                            ))}
                                        </div>
                                    </div>

                                    {/* AUM Section */}
                                    <div className="filter_section">
                                        <label className="filter_label">AUM</label>
                                        <div className="filter_buttons_row">
                                            {['≥ 5,000', '≥ 10,000', '≥ 50,000', '≥ 100,000'].map((a) => (
                                                <button
                                                    key={a}
                                                    className={`filter_row_btn ${aumFilter === a ? 'active' : ''}`}
                                                    onClick={() => setAumFilter(a)}
                                                >
                                                    {a}
                                                </button>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Minimum Copy Amount Section */}
                                    <div className="filter_section">
                                        <label className="filter_label">Minimum Copy Amount</label>
                                        <div className="filter_buttons_row">
                                            {['≤ 10', '≤ 50', '≤ 100', '≤ 1,000'].map((mca) => (
                                                <button
                                                    key={mca}
                                                    className={`filter_row_btn ${minCopyAmount === mca ? 'active' : ''}`}
                                                    onClick={() => setMinCopyAmount(mca)}
                                                >
                                                    {mca}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div className="filter_modal_footer">
                                    <button className="filter_reset_btn" onClick={handleResetFilters}>
                                        Reset
                                    </button>
                                    <button className="filter_confirm_btn" onClick={handleConfirmFilters}>
                                        Confirm
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            </div>
        </>
    );
};

export default CopyTrading;
